import i18n from "@/locales";

export const deleteSwal = {
  title: i18n.t("view.commons.swal.delete.title")
  , text: i18n.t("view.commons.swal.delete.text")
  , type: i18n.t("view.commons.swal.delete.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const disableSwal = {
  title: i18n.t("view.commons.swal.disable.title")
  , text: i18n.t("view.commons.swal.disable.text")
  , type: i18n.t("view.commons.swal.disable.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const clearSwal = {
  title: i18n.t("view.commons.swal.clear.title")
  , text: i18n.t("view.commons.swal.clear.text")
  , type: i18n.t("view.commons.swal.clear.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const logoutSwal = {
  title: i18n.t("view.commons.swal.logout.title")
  , text: i18n.t("view.commons.swal.logout.text")
  , type: i18n.t("view.commons.swal.logout.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const deleteProfileSwal = {
  title: i18n.t("view.commons.swal.deleteProfile.title")
  , text: i18n.t("view.commons.swal.deleteProfile.text")
  , type: i18n.t("view.commons.swal.deleteProfile.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const resetPasswordSwal = {
  title: i18n.t("view.commons.swal.resetPassword.title")
  , text: i18n.t("view.commons.swal.resetPassword.text")
  , type: i18n.t("view.commons.swal.resetPassword.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: true
  , reverseButtons: true
};

export const massUpdateSwal = {
  title: i18n.t("view.commons.swal.massUpdateSwal.title")
  , html: i18n.t("view.commons.swal.massUpdateSwal.html")
  , type: i18n.t("view.commons.swal.massUpdateSwal.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: false
  , reverseButtons: true
};

export const emailSendSwal = {
  title: i18n.t("view.commons.swal.emailSendSwal.title")
  , html: i18n.t("view.commons.swal.emailSendSwal.html")
  , type: i18n.t("view.commons.swal.emailSendSwal.type")
  , confirmButtonColor: i18n.t("view.commons.swal.common.confirmButtonColor")
  , cancelButtonColor: i18n.t("view.commons.swal.common.cancelButtonColor")
  , confirmButtonText: i18n.t("view.commons.swal.common.confirmButtonText")
  , cancelButtonText: i18n.t("view.commons.swal.common.cancelButtonText")
  , showCancelButton: false
  , reverseButtons: true
};



// WEBPACK FOOTER //
// ./src/constants/sweet-alerts.js